(() => {
  const translations = new Map([
    ['Canvas reproduction', 'Reproduction sur toile'],
    ['Choose your size', 'Choisissez votre format'],
    ['The format automatically adapts to the original artwork.', 'Le format s’adapte automatiquement aux proportions de l’œuvre.'],
    ['Calculated format', 'Format calculé'],
    ['Current offer', 'Prix actuel'],
    ['Workshop price', 'Prix atelier'],
    ['Unit', 'Unité'],
    ['Sizes', 'Formats'],
    ['Choose by longest side', 'Choisissez le côté le plus long'],
    ['Sizes adapted to the artwork proportions', 'Formats adaptés aux proportions de l’œuvre'],
    ['inch', 'pouces'],
    ['Oil painting on rolled canvas, unframed. Custom size available on request.', 'Peinture à l’huile sur toile roulée, sans cadre. Format personnalisé sur demande.'],
    ['ADD TO CART', 'AJOUTER AU PANIER'],
    ['Add to cart', 'Ajouter au panier']
  ]);

  const cleanLegacyMuseum = () => {
    document.body.classList.remove('alpha-product-museum', 'amp-open');
    document.querySelector('#alpha-product-museum-hero')?.remove();
    document.querySelectorAll('.amp-buy-intro,[data-amp-buy-intro]').forEach((element) => element.remove());
  };

  const translate = () => {
    cleanLegacyMuseum();
    const root = document.querySelector('[data-alpha-configurator]');
    if (!root) return;
    root.querySelectorAll('p,h2,span,label,button,option').forEach((element) => {
      const value = element.textContent.trim();
      if (translations.has(value)) element.textContent = translations.get(value);
    });
    root.dataset.sizeHintAdapted = 'Formats adaptés aux proportions de l’œuvre';
    root.dataset.sizeHintDefault = 'Choisissez le côté le plus long';
    root.dataset.messageAdded = 'La reproduction a été ajoutée à votre panier.';
    root.dataset.messageAddError = 'Impossible d’ajouter cette reproduction au panier pour le moment.';
  };

  document.addEventListener('DOMContentLoaded', translate, { once: true });
  document.addEventListener('shopify:section:load', translate);
  setTimeout(translate, 500);
  setTimeout(translate, 1600);
  setTimeout(translate, 3200);
})();
